export const blacklistedLoginPaths = [/^\/password-reset\//];
export const INTERNAL_SSO_ERROR_CODES = {
  userNotFound: 600,
  accountNotLinked: 601,
};
